var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-panel"},[_c('div',{staticClass:"right-section right-section-1 border-box"},[_c('OverallStats')],1),_c('div',{staticClass:"right-section right-section-2 border-box"},[_c('RightDiseaseRevenue')],1),_c('div',{staticClass:"right-section right-section-3 border-box"},[_c('RightRevisitRate')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }